<template>
  <div v-loading="loading" class="upload">
    <div v-for="(item, index) in documentType" :key="item.id">
      <UploadList
        :title="`${index + 1}. ${item[`name${$t('message.lan')}`]}`"
        :documentType="item"
        :application="application"
        :class="unUploadIds.includes(item.id) ? 'is-required' : ''"
        @change="handleChange($event, item.id)"
        @removeFile="removeFile(item.id)"
      >
      <template slot="after" v-if="unUploadIds.includes(item.id)">
          <div class="tips_red">{{ $t('message.upload_required_tips') }}</div>
        </template>
      </UploadList>
    </div>

    <div class="next_btn">
      <GradientBtn white @click="back">{{ $t("message.back") }}</GradientBtn>
      <GradientBtn @click="next" :disabled="loading">{{
        $t("message.DataRegistration.upload.next")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import UploadList from "./UploadList";
import GradientBtn from "../../../components/GradientBtn";
import DocumentTypeAPI from "../../../api/DocumentTypeAPI";
import HzmbApplicationAPI from "@/api/HzmbApplicationAPI";
import { applicantTypeFilter } from "@/filters";
export default {
  components: { UploadList, GradientBtn },
  data() {
    return {
      loading: false,
      application: null,
      serviceType: "",
      // documentType: []
      unUploadIds: [],
    };
  },
  computed: {
    documentType: {
      get() {
        return this.$store.state.documentType;
      },
      set(value) {
        this.$store.commit("changeDocumentType", value);
      },
    },
    driversLength() {
      const form = this.$store.state.form;
      return form.drivers.length;
    },
    applicantType() {
      return applicantTypeFilter(this.serviceType);
    },
  },
  watch: {
    driversLength() {
      this.getDocument();
    },
  },
  methods: {
    handleChange(file, id) {
      this.documentType = this.documentType.map((item) => {
        // if (process.env.VUE_APP_ENV == "development") {
        //   // 開發環境
        //   item.file = file;
        // } else {
        if (item.id == id) {
          item.file = file;
        }
        // }
        return item;
      });
      // 上傳成功後，移除必填提示
      this.unUploadIds = this.unUploadIds.filter(e => e !== id);
    },
    // 移除文件
    removeFile(id) {
      this.documentType = this.documentType.map((item) => {
        if (item.id == id) {
          delete item.file;
        }
        return item;
      });
    },
    next() {
      // 驗證必填項
      const documentType = this.documentType;
      let isCheck = true;
      this.unUploadIds = [];
      for (let i in documentType) {
        if (documentType[i].required && !documentType[i].file) {
          this.unUploadIds.push(documentType[i].id);
          isCheck = false;
        }
      }
      // console.log(isCheck);
      if (!isCheck) {
        this.$message({
          type: "error",
          message: this.$t("message.upload_required"),
        });
        setTimeout(() => {
          document
            .querySelector(".is-required")
            .scrollIntoView({ behavior: "smooth", block: "center", });
        }, 200);
        return false;
      } else {
        this.$router.push("/check");
      }
    },
    back() {
      this.$router.push("/formData");
    },
    getDocument() {
      const drivers = this.$store.state.form.drivers;
      this.loading = true;
      DocumentTypeAPI.get(this.$store.state.serviceType)
        .then((res) => {
          this.loading = false;
          let document = [];
          for (let i in res) {
            if (
              !(
                (drivers.length < 2 &&
                  (res[i].code == "1040" || res[i].code == "1030")) ||
                (drivers.length < 3 && res[i].code == "1040")
              )
            ) {
              document.push(res[i]);
            }
          }
          document = document.map((item) => {
            if (item.code == "1030" || item.code == "1040") {
              item.required = true;
            }
            return item;
          });
          const app = this.application || {};
          if (app.documents && app.documents.length > 0) {
            for (let i in app.documents) {
              let doc = app.documents[i];
              if (doc.documentType && doc.documentType.id) {
                // 儲存到對應文件類型中
                document = document.map((ele) => {
                  if (ele.id === doc.documentType.id) {
                    ele.file = {
                      uid: "-1",
                      name: doc.file && doc.file.filename,
                      size: doc.file && doc.file.fileSize,
                      status: "ready",
                    };
                    ele.document = doc;
                  }
                  return ele;
                });
              }
            }
          }
          // console.log(document);
          this.documentType = document;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
          // console.log(err);
        });
    },
    getVss() {
      return new Promise((resolve, reject) => {
        const serviceType = this.$store.state.serviceType;
        const verifyForm = this.$store.state.verifyForm;
        console.log(verifyForm);
        let identType = "BM";
        let identNo = verifyForm.identityNo;
        if (this.applicantType == "COMPANY") {
          if (verifyForm.companyType && verifyForm.companyNo) {
            identType = verifyForm.companyType;
            identNo = verifyForm.companyNo;
          } else {
            this.$message({
              type: "error",
              message: this.$t("message.different_login_type"),
            });
            this.$notify({
              type: "error",
              showClose: false,
              title: this.$t("message.tips"),
              message: this.$t("message.backToHome"),
              position: "bottom-right",
              duration: 4500,
            });
            setTimeout(() => {
              const page = localStorage.getItem("childTempTitle") || "one";
              if (page == "three") {
                this.$router.push("/entryTaxi");
              } else if (page == "two") {
                this.$router.push("/entryBus");
              } else {
                this.$router.push("/entry");
              }
            }, 5000);
            return;
          }
        }
        const spNo = verifyForm.spNo || null;
        const registrationNo = verifyForm.registrationNo || null;
        const identificationNo = verifyForm.identificationNo || null;
        HzmbApplicationAPI.getVss(
          serviceType,
          identType,
          identNo,
          spNo,
          registrationNo,
          identificationNo
        )
          .then((res) => {
            if (res.success) {
              this.application = res.application;
            } else {
              this.$message({
                type: "error",
                message: res.errorMsgs
                  .map((item) => {
                    return item.textCn;
                  })
                  .join("/n"),
              });
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  async created() {
    this.serviceType = this.$store.state.serviceType;
    await this.getVss();
    this.getDocument();
  },
};
</script>

<style lang="scss" scoped>
.upload {
  max-width: 690px;
  min-height: 500px;
  margin: 24px auto;
  background: #fff;
  overflow: hidden;
  padding-left: 14px;
  padding-right: 14px;
}
</style>